import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";

const Rail = styled.aside`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 40px;
    padding: 8px 4px;
    border-right: 1px solid #d3dde8;
    background: #eef3f7;
`;

const RailTop = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

const RailBottom = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    margin-top: auto;
    padding-top: 8px;
`;

const RailButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${(props) => (props.$active ? "#0f8f6f" : "transparent")};
    border-radius: 8px;
    background: ${(props) => (props.$active ? "#e4faf1" : "transparent")};
    cursor: pointer;

    &:hover {
        background: ${(props) => (props.$active ? "#e4faf1" : "#e4ebf2")};
    }
`;

function ManuscriptLeftRail({ activePanel, onSelect, onHelp, onSettings }) {
    return (
        <Rail>
            <RailTop>
                <RailButton
                    type="button"
                    aria-label="파일"
                    $active={activePanel === "files"}
                    onClick={() => onSelect("files")}
                >
                    <Tooltip message="파일" position="right">
                        <Icon name={"folder"} size={"16px"} color={activePanel === "files" ? "#0f8f6f" : "#6a7f97"} />
                    </Tooltip>
                </RailButton>
                <RailButton
                    type="button"
                    aria-label="검색"
                    $active={activePanel === "search"}
                    onClick={() => onSelect("search")}
                >
                    <Tooltip message="검색" position="right">
                        <Icon name={"search"} size={"16px"} color={activePanel === "search" ? "#0f8f6f" : "#6a7f97"} />
                    </Tooltip>
                </RailButton>
            </RailTop>
            <RailBottom>
                <RailButton type="button" aria-label="설정" onClick={onSettings}>
                    <Tooltip message="설정" position="right">
                        <Icon name={"option"} size={"16px"} color={"#6a7f97"} />
                    </Tooltip>
                </RailButton>
                <RailButton type="button" aria-label="도움말" onClick={onHelp}>
                    <Tooltip message="도움말" position="right">
                        <Icon name={"question"} size={"16px"} color={"#6a7f97"} />
                    </Tooltip>
                </RailButton>
            </RailBottom>
        </Rail>
    );
}

export default ManuscriptLeftRail;
